<template>    
  <div>
    <div class="row" v-if="compMode != CRUDMODE.READ">
      <table id="dataTablePersonCompany" width="100%" cellspacing="0" 
          class="table table-bordered table-striped dataTable"  >
        <thead>
          <tr>
            <th>{{ $t('project.company.form.angesRepresentative.name') }}</th>
 
            <th width="250">{{ $t('project.company.form.angesRepresentative.startDate') }}</th>
            <th width="250">{{ $t('project.company.form.angesRepresentative.endDate') }}</th>
            <th width="50" v-if="compMode != CRUDMODE.READ"></th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <th>{{ $t('project.company.form.angesRepresentative.name') }}</th>
            <th >{{ $t('project.company.form.angesRepresentative.startDate') }}</th>
            <th >{{ $t('project.company.form.angesRepresentative.endDate') }}</th>
            <th v-if="compMode != CRUDMODE.READ"></th>
          </tr>
        </tfoot>
        <tbody>
          <tr class="odd" v-if="angesRepresentatives.length == 0">
              <td valign="top" colspan="9" class="dataTables_empty">{{ $t("form.aucun_donne") }}</td>
          </tr>
          <tr v-for="(item, index) in angesRepresentatives" v-bind:data-id="item.id" :key="item.id">
            <td>
              
              <multiselect v-model="item.member" id="ajax" :custom-label="memberLabel" 
                track-by="id" :placeholder="$t('project.company.form.conseil.member')" open-direction="bottom" 
                :options="members" :multiple="false" :searchable="true" :loading="isLoading" 
                :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                :options-limit="300" :max-height="600" :show-no-results="true" 
                :hide-selected="true" @search-change="asyncMemberFind"
                :select-label="$t('multiselect.select-label')">

                <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
              </multiselect>
            </td>
             <td>
                   <moment-date-picker v-model="item.startDate" :required="true"></moment-date-picker>
               </td> 
            <td>
                   <moment-date-picker v-model="item.endDate" :required="true"></moment-date-picker>
            </td>
            <td align=center v-if="compMode != CRUDMODE.READ">
              <a class="text-danger" v-bind:title="$t('form.delete_button')" href="#person" v-on:click="removePerson(index)">
                  <span class="fa fa-lg fa-trash"></span>
              </a>
            </td> 
          </tr>
        </tbody>
      </table>
    </div>

    <ul class="item-view" v-if="compMode == CRUDMODE.READ">
      <li v-if="angesRepresentatives == null || angesRepresentatives.length == 0">
        {{ $t("form.aucun_donne") }}
      </li>
      <li v-for="item in angesRepresentatives" v-bind:data-id="item.id" :key="item.id">

        <div class="row">
          <div class="form-group col-md-4">
            <label>{{ $t('project.company.form.conseil.person') }}</label>
            <div class="input-group mb-3">
              <input :value="item.member.familyName + ', ' + item.member.name" type=text class="form-control" disabled />
              <div class="input-group-append" v-if="item.type != 4">
                <button class="btn btn-outline-secondary" v-on:click.stop="showPersonPage(item)" type="button"><span class="fa fa-lg fa-link"></span></button>
              </div>
            </div>
            
          </div>
          <div class="form-group col-md-1">
            <label>{{ $t('project.company.form.angesRepresentative.startDate') }}</label>
            <input v-model.trim="item.startDate" v-mask="'##/##/####'" v-validate="'date_format:DD/MM/YYYY'" name="constitutionDate" 
                type="text" class="form-control" id="constitutionDateInput" placeholder="DD/MM/YYYY" disabled  />

          </div>
          <div class="form-group col-md-1">
            <label>{{ $t('project.company.form.angesRepresentative.endDate') }}</label>
            <input v-model.trim="item.endDate" v-mask="'##/##/####'" v-validate="'date_format:DD/MM/YYYY'" name="constitutionDate" 
                type="text" class="form-control" id="constitutionDateInput" placeholder="DD/MM/YYYY" disabled  />

          </div>
        </div>
      </li>
    </ul>
   
  </div>
        
</template>

<script>
  import {
    CompanyServiceClient,
    CompanyPersonServiceClient,
    CompanyPersonDto,
    MemberServiceClient,
    UserServiceClient,
    EntrepreneurServiceClient,
    MemberDto,
    UserDto,
    EntrepreneurDto,
  } from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import Multiselect from 'vue-multiselect'
  import Datepicker from 'vuejs-datepicker'
  import MomentDatePicker from '../../shared/components/MomentDatePicker'

  export default {
    name: 'AngesRepresentative',
    props: {
      companyPersons: {},
    },
    data() {
      return {
        members: [],
        isLoading: false,
        angesRepresentatives: [],
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.angesRepresentatives = self.companyPersons
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      showPersonPage: function(item) {
        let routeData = null
        if (item.type == 1)
          // Member
          routeData = this.$router.resolve({path: '/members/view/' + item.memberId})
        else if (item.type == 2)
          // User
          routeData = this.$router.resolve({path: '/users/edit/' + item.associatedUserId})
        else if (item.type == 3)
          // Entrepreneur
          routeData = this.$router.resolve({path: '/entrepreneurs/view/' + item.entrepreneurId})

        if (routeData != null) window.open(routeData.href, '_blank')
      },
      fetchData: function() {
        let companyService = ServiceFactory.create(CompanyServiceClient)
        let getPersonRole = companyService.getPersonRole()
        let self = this

        getPersonRole
          .then(res => {
            self.roles = res
          })
          .catch(err => {
            console.log(err)
          })
        //6 = AngesRepresentative, we only want that here.
        this.angesRepresentatives = this.angesRepresentatives.filter(c => c.personRole == 6)
      },
      addAngesRepresentative: function() {
        let dto = new CompanyPersonDto()
        dto.init({personRole: 6})
        this.companyPersons.push(dto)
        this.angesRepresentatives.push(dto)
      },
      removePerson: function(index) {
        this.companyPersons.splice(index, 1)
        this.angesRepresentatives.splice(index, 1)
      },
  
      asyncMemberFind: function(query) {
        this.isLoading = true
  
        let service = ServiceFactory.create(MemberServiceClient)
        let self = this

        service.getAutocomplete(query).then(response => {
          self.members = _.map(response, item => {
            let dto = new MemberDto()
            dto.init(item)
            return dto
          })
          self.isLoading = false
        })
      },
      memberLabel: function(obj) {
        return obj.familyName + ', ' + obj.name
      },
    },
    components: {
      multiselect: Multiselect,
      Datepicker,
      'moment-date-picker': MomentDatePicker,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/projects/AngesRepresentative.vue